<template>
    <div class="flex items-center justify-center min-h-screen bg-surface-50 dark:bg-surface-900">
        <router-view />
    </div>
</template>
